import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from '../../core';
import { NavbarComponent } from '../navbar';
import { SidebarComponent } from '../sidebar';


/**
 * Main container of application.
 */
@Component({
	selector: 'container-template',
	templateUrl: './container-template.component.html',
	imports: [
		SidebarComponent,
		NavbarComponent,
		RouterOutlet,
		ToastComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ContainerTemplateComponent { }
